import React, { useEffect, useState } from "react";
import { IoStar } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import img3 from "../../images/Group 28.png";
import { FaHeart } from "react-icons/fa";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import "./Wishlist.css";
import axios from "axios";
import { BASE_URL } from "../../constant";
import wishlistImg from "../../images/wishlist-icon.jpg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCartContext } from "../../Context/CartContext";
import { FaRegStar, FaStar } from "react-icons/fa6";
import { TbZoomIn } from "react-icons/tb";
// import { TbZoomIn } from "react-icons/tb";
import { useWishlistContext } from "../../Context/WishlistContext";
import FlashSale from "../Flash Sale/FlashSale";
import { RxMagnifyingGlass } from "react-icons/rx";

const Wishlist = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState([]);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const stars = Array.from({ length: 5 });
  const [productDetails, setProductDetails] = useState(null);
  const { fetchWishlistCount } = useWishlistContext();
  const [cartItems, setCartItems] = useState([]);
  const { fetchCartCount } = useCartContext();
  const [wishlistItems, setWishlistItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [reviews, setReviews] = useState([]);

  // Function to fetch wishlist items
  const fetchWishlistItems = async () => {
    if (userId) {
      try {
        const response = await axios.get(`${BASE_URL}/wishlist/get/${userId}`);
        setWishlistItems(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching wishlist items:", error);
      }
    }
  };

  const fetchCartItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId}&pageSize=10000`
        );
        console.log(response.data);
        setCartItems(response.data);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    }
  };

  useEffect(() => {
    const fetchProductDetails = async () => {
      const userId = localStorage.getItem("userId");
      try {
        const response = await axios.get(
          `${BASE_URL}/products/productId?userId=${userId}&id=${productId}`
        );
        setProductDetails(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    const fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/product-ratings/product/${productId}`
        );
        setReviews(response.data);
        // console.log(response.data)
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };
    fetchProductDetails();
    fetchReviews();
  }, [productId]);

  useEffect(() => {
    fetchWishlistItems();
    fetchCartItems();
  }, [userId]);

  const removeWishlistItem = async (productId) => {
    const updatedWishlist = wishlistItems.filter(
      (item) => item.productId !== productId
    );
    setWishlistItems(updatedWishlist);

    try {
      const response = await axios.delete(
        `${BASE_URL}/wishlist/delete/${userId}/${productId}`
      );
      console.log(response);
      fetchWishlistCount();
      toast.error("Product removed from wishlist");
    } catch (error) {
      console.error("Error removing product from wishlist:", error);

      setWishlistItems([...wishlistItems, { productId }]);
      toast.error("Something went wrong! Try again later");
    }
  };

  const handleClearWishlist = async () => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/wishlist/delete-all/${userId}/clear`
      );
      setWishlistItems([]);
      await fetchWishlistCount();
      console.log(response);
      toast.success("Wishlist Cleared");
    } catch (error) {
      console.error("Error clearing wishlist:", error);
      toast.error("Something went wrong! Try again later");
    }
  };

  const handleAddToCart = async (productId) => {
    if (userId) {
      try {
        const cartResponse = await axios.post(
          `${BASE_URL}/usercart/add-product?userId=${userId}&productId=${productId}&orderQuantity=1`
        );
        // await removeWishlistItem(productId);
        // fetchWishlistCount();
        await fetchCartCount();
        toast.success("Product added to cart");
        fetchCartItems();
        // navigate("/cart");
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/signup");
    }
  };

  const handleZoomClick = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div>
      <Header />
      <ToastContainer />
      <div className="wishlist-container">
        {wishlistItems.length > 0 ? (
          <div className="wishlist-top">
            <h1>Wishlist</h1>

            <button
              onClick={handleClearWishlist}
              className="wishlist-clear-btn"
            >
              Clear Wishlist
            </button>
          </div>
        ) : (
          ""
        )}

        {wishlistItems.length > 0 ? (
          <div className="wishlist-product-items">
            {wishlistItems.map((item) => {
              const isInCart = cartItems.some(
                (cartItem) => cartItem.productid === item.productId
              );
              const firstPhotoUrl = item.product.prodImg1
                ? item.product.prodImg1
                : "https://balache-kapde-media.s3.ap-south-1.amazonaws.com/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
              return (
                <div key={item.productId} className="wishlist-product-card">
                  <div className="wishlist-product-image">
                    <img
                      src={firstPhotoUrl}
                      alt={item.product.productName}
                      onClick={() =>
                        navigate(`/productdetails/${item.productId}`)
                      }
                    />
                    <RxMagnifyingGlass
                      id="magnifying-glass-icon"
                      size={30}
                      onClick={() => handleZoomClick(firstPhotoUrl)}
                    />
                  </div>
                  <div className="wishlist-product-info">
                    <h2 className="wishlist-product-name">
                      {item.product.productName}
                    </h2>
                    {/* Uncomment if needed */}
                    <p className="wishlist-product-description">
                      {item.product.prdDesc}
                    </p>
                    <div className="price">
                      <span style={{ display: "flex", gap: "10px" }}>
                        <p style={{ textDecoration: "line-through" }}>
                          Rs {item.product.productMRP}
                        </p>
                        <p>Rs {item.product.productRate}</p>
                      </span>
                    </div>
                    <div className="wishlist-product-icons">
                      {/* {stars.map((_, index) => (
                        <IoStar key={index} />
                      ))}
                      <p style={{ color: "black" }}>(145)</p> */}
                      {[...Array(5)].map((_, index) => (
                        <FaStar
                          key={index}
                          color={
                            index < Math.round(product.productRatings)
                              ? "#ffc35b"
                              : "#e4e5e9"
                          }
                        />
                      ))}
                      <span style={{ color: "black" }}>
                        ({product.productRatings}){" "}
                      </span>
                    </div>
                    <div className="wishlist-product-card-btn ">
                      {/* <button
                        className="wishlist-add-to-cart"
                        onClick={() => handleAddToCart(item.productId)}
                      >
                        Add to Cart
                      </button> */}
                      {item.product.productQuantity > 0 ? (
                        isInCart ? (
                          <button
                            className="wishlist-add-to-cart"
                            style={{ background: "#0BDA51 " }}
                          >
                            Added to Cart
                          </button>
                        ) : (
                          <button
                            className="wishlist-add-to-cart"
                            onClick={() =>
                              navigate(
                                `/productdetails/${item.product.productId}`
                              )
                            }
                          >
                            Shop Now
                          </button>
                        )
                      ) : (
                        <button className="wishlist-add-to-cart" disabled>
                          Out of Stock
                        </button>
                      )}
                      <button
                        className="wishlist-add-to-wishlist"
                        onClick={() => removeWishlistItem(item.productId)}
                      >
                        <FaHeart size={20} />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-wishlist">
            <img src={wishlistImg} width={"200px"} />
            <h3 style={{ fontSize: "30px" }}>Your Wishlist is Empty!</h3>
            <p style={{ fontSize: "20px" }}>
              Add items in your wishlist to buy them later.
            </p>
            <button
              className="empty-cart-btn"
              type="submit"
              onClick={() => navigate("/shop")}
            >
              Add Products
            </button>
          </div>
        )}
      </div>
      {/* Modal for Image Zoom */}
      {isModalOpen && (
        <div className="image-modal-overlay" onClick={closeModal}>
          <div className="image-modal-content">
            <span className="image-modal-close" onClick={closeModal}>
              ×
            </span>
            <img src={selectedImage} alt="Zoomed" />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Wishlist;
